module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "web-menu"
  }, [_c('div', {
    staticClass: "iterm-l web-iterm quickTool",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.quickFile = !_vm.quickFile
      }
    }
  }, [_vm._v("\n      快速引入\n      "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quickFile),
      expression: "quickFile"
    }],
    staticClass: "drop-down-content"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.quickTool(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.library))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "iterm-r"
  }, [_c('div', {
    staticClass: "run-switch",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.checkHand.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.isHand) ? _c('a', {
    staticClass: "click-run",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.compileWeb.apply(null, arguments)
      }
    }
  }) : _c('a', {
    staticClass: "web-iterm",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("自动运行")])])]), _vm._v(" "), _c('iframe', {
    ref: "webConsole",
    staticClass: "resultIframe",
    attrs: {
      "frameBorder": "0",
      "src": "#/runner"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36930db9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Browser/index.vue
// module id = 509
// module chunks = 1